import React, {FunctionComponent, useContext} from 'react';
import {observer} from "mobx-react";
import {Select, MenuItem} from "@material-ui/core";
import {Context} from "../../../store/context";

interface ILanguageDropdown{
    onChange?: (ietf:string)=>void;
}

const LanguageDropdown:FunctionComponent<ILanguageDropdown> = (props) => {
    const {languagesStore} = useContext(Context)

    if(!languagesStore.currentIETF)
        return null;

    const handleSelectChange = (e) => {
        languagesStore.setSelectedIETF(e.target.value);

        if(props.onChange)
            props.onChange(e.target.value);
    }

    return <Select value={languagesStore.currentIETF} onChange={handleSelectChange}>
        {
            languagesStore.availableLanguages.map(l =>
                <MenuItem key={l.ietf} value={l.ietf}>
                    {l.language_name}
                </MenuItem>
            )
        }
    </Select>
};

export default observer(LanguageDropdown);
